import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/AppShell";
import { api, errMsg } from "@/lib/api";

export function AdRailSettingsCard() {
  const [slot, setSlot] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/site-settings").then((r) => setSlot(r.data.ad_rail_slot || "")).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/admin/site-settings", { ad_rail_slot: slot }); setSlot(r.data.ad_rail_slot); toast.success(r.data.ad_rail_slot ? "Side ads turned on" : "Side ads turned off"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Panel title="Side-rail ads" className="mb-6" testid="ad-rail-settings-card">
      <p className="text-sm text-muted-foreground mb-3">In AdSense, go to Ads → By ad unit → Display ads, choose a <strong>Vertical</strong> shape, create it, and paste the number from <code>data-ad-slot="…"</code> here. The ad shows in a narrow column beside the content on wide screens (not on legal, login or account-sharing pages). Leave blank to turn it off.</p>
      <div className="flex gap-2 max-w-md">
        <Input value={slot} onChange={(e) => setSlot(e.target.value.replace(/\D/g, ""))} placeholder="e.g. 1234567890" className="font-mono-num" data-testid="ad-rail-slot-input" />
        <Button onClick={save} disabled={busy} className="rounded-full" data-testid="ad-rail-save-button">{busy ? "Saving..." : "Save"}</Button>
      </div>
    </Panel>
  );
}
